import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'bookings',
    loadComponent: () => import('./components/bookings/bookings.component').then(m => m.BookingsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'new-booking',
    loadComponent: () => import('./components/new-booking/new-booking.component').then(m => m.NewBookingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-booking/:id',
    loadComponent: () => import('./components/edit-booking/edit-booking.component').then(m => m.EditBookingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadComponent: () => import('./components/settings/settings.component').then(m => m.SettingsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
